// modules/CheckboxGroupField.jsx
import React from "react";
import {
  FormControl,
  FormLabel,
  FormGroup,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from "@mui/material";

const CheckboxGroupField = ({
  module,
  value,
  isEditable,
  onChange,
  fieldKey,
  isCustom = false,
}) => {
  const selectedOptions = Array.isArray(value) ? value : [];
  return (
    <FormControl
      component="fieldset"
      margin="normal"
      required={module.required}
      disabled={!isEditable}
      sx={{
        width: "95%",
        marginBottom: 2,
        ...(isCustom && { backgroundColor: "#f5f5f5", padding: 2 }),
      }}
    >
      <FormLabel component="legend">{module.label}</FormLabel>
      <FormGroup
        sx={{
          display: "flex",
          flexDirection: isCustom ? "row" : "column",
          gap: 1,
        }}
      >
        {module.options.map((option, idx) => (
          <FormControlLabel
            key={idx}
            control={
              <Checkbox
                checked={selectedOptions.includes(option)}
                onChange={(e) => {
                  let newValue = [...selectedOptions];
                  if (e.target.checked) {
                    newValue.push(option);
                  } else {
                    newValue = newValue.filter((val) => val !== option);
                  }
                  onChange(fieldKey, newValue);
                }}
                disabled={!isEditable}
              />
            }
            label={option}
          />
        ))}
      </FormGroup>
      {module.required && (!value || value.length === 0) && (
        <FormHelperText error>Please select at least one option</FormHelperText>
      )}
    </FormControl>
  );
};

export default CheckboxGroupField;
